import { pushEventOnDataLayer } from '../services/gaDataLayer'

export const calculateActiveTime = (startTime: string | null, storedTime: string): number => {
    if (!startTime) return parseInt(storedTime, 10)

    const now = Date.now()
    const activeDuration = now - parseInt(startTime, 10)
    return parseInt(storedTime, 10) + activeDuration
}

export const updateCameraActiveTime = (isEndClass: boolean = false): string => {
    const cameraStartTime = sessionStorage.getItem('cameraStartTime')
    let storedTime = sessionStorage.getItem('cameraActiveTime') || '0'

    const totalActiveTime = calculateActiveTime(cameraStartTime, storedTime)
    storedTime = totalActiveTime.toString()

    if (!isEndClass) {
        sessionStorage.setItem('cameraActiveTime', storedTime)
    } else {
        sessionStorage.removeItem('cameraActiveTime')
    }

    sessionStorage.removeItem('cameraStartTime')
    return storedTime
}

export const pushCameraUsageToGA = (): void => {
    const storedTime = updateCameraActiveTime(true)

    const userEventData = {
        user_id: sessionStorage.getItem('userId') || '',
        role: sessionStorage.getItem('role') || '',
        class_id: sessionStorage.getItem('classroomId') || '',
        camera_usage_time: storedTime || '0'
    }

    pushEventOnDataLayer('camera_usage_time', userEventData)
}
